import Api from '.';

class OCRTemplateApi extends Api {
  base_endpoint = 'ocr-template-types';
}

export default new OCRTemplateApi();
